import { useState } from 'react'
import {
    TableContainer,
    Table,
    Thead,
    Tr,
    Td,
    Th,
    WrapItem,
    Tooltip,
    Button,
    Box,
    Stack,
    Flex,
    HStack,
    Text,
} from '@chakra-ui/react'
import { 
    DeleteIcon, 
    EditIcon, 
    CopyIcon,
} from '@chakra-ui/icons'
import { 
    AiOutlineWarning,
} from 'react-icons/ai'
import "/node_modules/flag-icons/css/flag-icons.min.css"

import StationDisplayElement from '../ui/StationDisplayElement'
import UserReportPopover from '../UserReportPopover'

import Moment from 'moment'

import { 
    getFormattedDistance, 
    getFormattedDuration,
} from '../../utilities/formattingHelper'


export function TableCustom(props) {
    return (
        <TableContainer>
            <Table>
                {props.children}
            </Table>
        </TableContainer>
    )
}

export function TableCustomHeading(props) {
    const { additionalElements } = props

    return (
        <Thead>
            <Tr>
                <Th>From</Th>
                <Th>To</Th>

                {additionalElements && additionalElements.map(heading => (
                    <Th>{heading}</Th>
                ))

                }

                <Th></Th>
            </Tr>
        </Thead>
    )
}

function TableCustomTdStationName({ station }) {
    return (
        // <Td maxWidth='300px'> // Station name text wrapping or whatever...
        <Td>
            <StationDisplayElement
                station={station}
            />
        </Td>
    )
}

function TableCustomTdText({ text }) {
    const isTextExpandable = text.length > 15;

    return (
        <Td>
            {isTextExpandable ? (
                <Tooltip label={text} closeDelay={500}>
                    <HStack spacing={1}>
                        <Text>{text.substring(0, 20)}...</Text>
                    </HStack>
                </Tooltip>
            ) : (
                text
            )}
        </Td>
    )
}

function TableCustomButton({ onClick, variant, ...props }){
    const iconMap = {
        edit: <EditIcon />,
        delete: <DeleteIcon />,
        duplicate: <CopyIcon />,
    };

    const icon = iconMap[variant] || null;
    const description = variant ? variant.charAt(0).toUpperCase() + variant.slice(1).toLowerCase() : '';

    return (
        <WrapItem>
            <Tooltip label={description} hasArrow>
                <Button
                    onClick={onClick}
                    variant='outline'
                    size='sm'
                    {...props}
                >
                    {icon}
                </Button>
            </Tooltip>
        </WrapItem>
    )
}

export function TableCustomRow(props) {
    const {
        from, to, cannotMap, // In all cases, including future creator export map
        date, distance, length, note, // Journey
        operator // Journey optional
    } = props

    const [isUserReportPopoverShown, setIsUserReportPopoverShown] = useState(false)

    return (
        <Tr>
            <TableCustomTdStationName
                station={from}
            />
            <TableCustomTdStationName
                station={to}
            />

            {date && (<Td>{Moment(date).format('Do MMM YYYY')}</Td>)}
            {distance !== 0 ? 
                (<Td>{getFormattedDistance(distance, 'km')} km</Td>) 
                : 
                ( <Td>
                    <Tooltip 
                        isDisabled={isUserReportPopoverShown}
                        label='This journey cannot be displayed on a map and distance cannot be calculated. Click to learn more.' 
                        closeDelay={100} 
                        hasArrow
                        placement="bottom"
                        isLazy
                    >
                        <Flex justify="center" align="center" height="100%">
                            <UserReportPopover type='unmappedRoute' journeyId={props.id}>
                                <Button variant='outline' onClick={() => setIsUserReportPopoverShown(!isUserReportPopoverShown)}>
                                    <AiOutlineWarning />
                                </Button>
                            </UserReportPopover>
                        </Flex>
                    </Tooltip>
                </Td>)}
            {length !== undefined && (<Td>{getFormattedDuration(length)}</Td>)}
            {operator !== undefined && (operator !== '' ? (<TableCustomTdText text={operator} />) : (<Td></Td>))}
            {note !== undefined && (note !== '' ? (<TableCustomTdText text={note} />) : (<Td></Td>))}

            {/* Actions/unlabeled column */}
            <Td>
                <Stack 
                    direction='row' 
                    align='center'
                >
                    <TableCustomButton
                        onClick={props.editButtonOnClick}
                        variant='edit'
                    />

                    <TableCustomButton
                        onClick={props.duplicateButtonOnClick}
                        variant='duplicate'
                    />

                    <TableCustomButton
                        onClick={props.deleteButtonOnClick}
                        variant='delete'
                    />
                </Stack>
            </Td>

        </Tr>
    )

}